/*
 * @Author: Teemo Ding
 * @Date: 2022-03-09 17:45:59
 * @LastEditTime: 2022-05-09 08:37:57
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/AuditTrail/Communication/CommunicationDetail/CommunicationDetails/index.tsx
 */
import React, { Fragment } from 'react';
import Link from 'src/components/Link/Link';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { templateCategoryList } from 'src/pages/Settings/Communication/CommunicationTemplateDetail/config';
import { calculateCommunication } from 'src/pages/Settings/Communication/tool';
import { i18nGet, handleOnFormatStoreTimeAndDate } from 'src/tools/tools';
import { CommunicationChannelType } from 'src/types/common/communication';
import { maskEmail, maskPhone } from '@/src/tools/mask';
import { getContactName } from '../tool';
import VisibilityToggle from '@/src/components/VisibilityToggle';
import css from '../css.module.less';

const CommunicationDetails = ({ data }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [isVisible, setIsVisible] = React.useState(false);
  const {
    salesChannelName,
    contactName,
    fullName,
    lastName,
    firstName,
    channelType,
    sentTo,
    sentBy,
    status,
    category,
    templateName,
    language,
    gatewayName,
    orderUuid,
    remarks,
    content,
    reportingSendAt,
    customerDBName,
    salesChannelSendAt,
    customerDBUuid,
    customerUuid,
    reportingTimeZoneInGmt,
    salesChannelTimeZoneInGmt,
    gateway,
    uuid,
  } = data || {};
  const categoryName = templateCategoryList.reduce((pre, now) => {
    const nowIndex = now.children.filter((o) => o.value === category);
    if (nowIndex.length) {
      pre = ((nowIndex || [])[0] || {}).label;
    }
    return pre;
  }, '');

  const channelTypeName = calculateCommunication(
    (gateway || {}).gatewayProvider,
    channelType,
    { getI18n },
  ).channelType;
  return (
    <SectionWrapper
      id={'DirectDiscountBasicInfo'}
      containerClassName={css.sectionContainer}
      titleClassName={css.titleClassName}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>
            {getI18n('communication.communicationDetails.basicInformation')}
          </span>
          <VisibilityToggle defaultVisible={false} onToggle={setIsVisible} />
        </div>
      }>
      <Fragment>
        {uuid && (
          <div className={css.informationItem}>
            <h3>
              {getI18n('communication.communicationDetails.communicationID')}
            </h3>
            <span>{uuid}</span>
          </div>
        )}
        {contactName && (
          <div className={css.informationItem}>
            <h3>{getI18n('communication.communicationDetails.contactName')}</h3>
            <Link
              className={css.link}
              to={`/customerDatabase/customerDetail/${customerDBUuid}/${customerUuid}`}>
              {getContactName({
                customerUuid,
                fullName,
                lastName,
                firstName,
                isVisible,
                contactName,
                channelType,
              })}
            </Link>
          </div>
        )}
        {channelType && (
          <div className={css.informationItem}>
            <h3>
              {getI18n(
                'communication.communicationDetails.communicationchannel',
              )}
            </h3>
            <span>{channelType}</span>
          </div>
        )}
        {sentTo && (
          <div className={css.informationItem}>
            <h3>{getI18n('communication.communicationDetails.sentto')}</h3>
            <span>
              {sentTo && channelType === CommunicationChannelType.SMS
                ? `+ ${isVisible ? sentTo : maskPhone(sentTo, true)}`
                : isVisible
                ? sentTo
                : maskEmail(sentTo)}
            </span>
          </div>
        )}
        {sentTo && (
          <div className={css.informationItem}>
            <h3>{getI18n('communication.communicationDetails.sentby')}</h3>
            <span>{sentBy}</span>
          </div>
        )}
        {(reportingSendAt || salesChannelSendAt) && (
          <div className={css.informationItem}>
            <h3>{getI18n('communication.communicationDetails.sentdate')}</h3>
            <div className={css.sentDate}>
              <span>
                {handleOnFormatStoreTimeAndDate(reportingSendAt)} (UTC{' '}
                {reportingTimeZoneInGmt}){' '}
                {getI18n(
                  'communication.communicationDetails.reportingtimezone',
                )}
              </span>
              <span>
                {handleOnFormatStoreTimeAndDate(salesChannelSendAt)} (UTC{' '}
                {salesChannelTimeZoneInGmt}){' '}
                {getI18n(
                  'communication.communicationDetails.salesChanneltimezone',
                )}
              </span>
            </div>
          </div>
        )}
        {status && (
          <div className={css.informationItem}>
            <h3>{getI18n('communication.communicationDetails.status')}</h3>
            <span>{status}</span>
          </div>
        )}
        {categoryName && (
          <div className={css.informationItem}>
            <h3>
              {getI18n(
                'communication.communicationDetails.communicationCategory',
              )}
            </h3>
            <span>{categoryName}</span>
          </div>
        )}
        {templateName && (
          <div className={css.informationItem}>
            <h3>
              {getI18n('communication.communicationDetails.templateName')}
            </h3>
            <span>{templateName}</span>
          </div>
        )}
        {language && (
          <div className={css.informationItem}>
            <h3>
              {getI18n('communication.communicationDetails.templateLanguage')}
            </h3>
            <span>{language}</span>
          </div>
        )}
        {gatewayName && (
          <div className={css.informationItem}>
            <h3>
              {getI18n(
                'communication.communicationDetails.communicationgateway',
              )}
            </h3>
            <span>
              {gatewayName}({(gateway || {}).gatewayProvider} -{' '}
              {channelTypeName})
            </span>
          </div>
        )}
        {orderUuid && (
          <div className={css.informationItem}>
            <h3>{getI18n('communication.communicationList_config.orderID')}</h3>
            <Link className={css.link} to={`/orderCreate/${orderUuid}`}>
              {`#order ${orderUuid}`}
            </Link>
          </div>
        )}
        {salesChannelName && (
          <div className={css.informationItem}>
            <h3>{getI18n('general.sider.salesChannel')}</h3>
            <span>{salesChannelName}</span>
          </div>
        )}
        {customerDBName && (
          <div className={css.informationItem}>
            <h3>
              {getI18n(
                'communication.communicationList_config.customerDatabase',
              )}
            </h3>
            <span>{customerDBName}</span>
          </div>
        )}
        {remarks && (
          <div className={css.informationItem}>
            <h3>{getI18n('general.remarks')}</h3>
            <span>{remarks}</span>
          </div>
        )}
        {content && (
          <div className={css.informationItem}>
            <h3>{getI18n('communication.communicationDetails.content')}</h3>
            <span>{content}</span>
          </div>
        )}
      </Fragment>
    </SectionWrapper>
  );
};

export default CommunicationDetails;
